import React, { Component } from "react";
import PropTypes from "prop-types";

// material-ui
import { withStyles } from "@material-ui/core/styles";

// custom
import Table from "components/Table";

// styles
import styles from "./styles";

class MemberTagsList extends Component {
  static propTypes = {
    classes: PropTypes.object,
    memberTags: PropTypes.array,
    onSelect: PropTypes.func,
  };

  onSelect(selectedMemberTag) {
    const { onSelect } = this.props;
    this.setState({ selectedMemberTag });
    if (onSelect) {
      onSelect(selectedMemberTag);
    }
  }

  render() {
    const { memberTags } = this.props;

    return (
      <Table
        data={memberTags}
        meta={[
          {
            path: "name",
            title: "Name",
            numeric: false,
            hidden: { mdDown: true },
          },
        ]}
        title={"MemberTags"}
        onRowSelect={this.onSelect.bind(this)}
      />
    );
  }
}

export default withStyles(styles)(MemberTagsList);
